import React from "react";
import PropTypes from "prop-types";

import { Box, Typography, Button } from "@mui/material";

const Header = ({ onClick }) => {

  return (
    <>
      <Box sx={{ p: 2, borderBottom: "1px solid rgba(0,0,0,0.1)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="subtitle2">Link-In-Bio Blocks</Typography>
        
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="outlined"
            size="small"
            startIcon={
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            }
            sx={{ 
              borderRadius: 1,
              textTransform: "none",
              fontWeight: "medium",
              fontSize: "0.75rem"
            }}
            onClick={onClick}
          >
            Create New
          </Button>
        </Box>
      </Box>
    </>
  );
};

Header.propTypes = {
  onClick: PropTypes.func,
};

export default Header;
